@if(model()) {
  <div class="flex flex-col w-full lg:w-3/4 mx-auto">
    @if ((model().submissionType === 'Renewal' || model().submissionType==='Rewrite') && status() === 'Producer Review') {
      <div class="review-banner ">
        <div>
          <h4>Change Request</h4>
          <p class="medium">Click Manage Submission to modify the details and submit for underwriter review.</p>
        </div>
        <lib-button [cssType]="'btn-primary'" [icon]="'rightarrow'" [text]="'Manage Submission'" [size]="'small'" (click)="manageSubmission()"></lib-button>
      </div>
    }
    <div class="flex w-full">
      <div class="w-1/2">
        <p class="bold">{{ model().businessName }}</p>
        <p><span>Contractors License Number: </span>{{ model().licenseNumber ? model().licenseNumber : ''}}</p>
      </div>
      <div class="w-1/2">
        <p><span class="bold">Retail Agency: </span>{{model().retailAgency}}</p>
        <p><span class="bold">Retail Producer: </span>{{model().retailProducer}}</p>
      </div>
    </div>

    <div class="flex w-full mt-3">
      <div class="w-1/2">
        <p><span class="bold">Business Type: </span>{{model().businessType}}</p>
        <p class="bold">Primary Business Address:</p>
        <p>{{ model().businessAddress}}</p>
        <p>{{model().city}}, {{model().state}} {{model().zipCode}}</p>
      </div>
      <div class="w-1/2">
        <p><span class="bold">Quote Type: </span>{{model().submissionType}}</p>
      </div>
    </div>

    <div class="flex w-full mt-5">
      <div class="w-1/2">
        <p><span class="bold">Annual Gross Receipts: </span> {{model().grossReceipts | currency}}</p>
        <p><span class="bold">Residential Subcontractor Labor Costs (91583):</span> {{model().residentialSubcontractorCosts | currency}}</p>
        <p><span class="bold">Commercial Subcontractor Labor Costs (91585):</span> {{model().commercialSubcontractorCosts | currency}}</p>
        <p><span class="bold">Description of Operations:</span> {{model().descriptionOfOperations}}</p>
      </div>

      <div class="w-1/2">
        @if (hasFieldOwners()) {
          <p><span class="bold">Owners in the Field: </span> {{model().numberOfFieldOwners}}</p>
          <p><span class="bold">Owner Payroll: </span> {{model().ownerPayroll | currency:'USD'}}</p>
        }
        <p><span class="bold">Number of Employees </span> {{model().numberOfEmployees}}</p>
        @if (hasFieldOwners()) {
          <p><span class="bold">Employee Payroll: </span> {{model().employeePayroll | currency:'USD'}}</p>
        }
        <p><span class="bold">Current and Continuous Coverage? </span> {{model().currentAndContinualCoverage}}</p>
        <p><span class="bold">Policy Effective Date: </span> {{model().effectiveDate}}</p>
      </div>
    </div>
  </div>

  @if(model().requestType === 'Bind') {
    <div class="mt-[35px] flex flex-col w-full lg:w-3/4 mx-auto">
      <div class="flex w-full">
        <p class="bold">Documents</p>
      </div>

      <div class="mt-3 flex w-full">
        <div class="w-1/2">
          <p>Signed Application</p>
          <ng-container *ngIf="viewSubmissionStore.applicationDocuments().length > 0">
            @for(application of viewSubmissionStore.applicationDocuments(); track application) {
              <lib-button class="underline" [cssType]="'btn-link'" [buttonType]="'button'" [text]="application?.name ?? ''"  [size]="'medium'" (click)="downloadDocument(application?.id ?? '')"></lib-button><br>
            }
          </ng-container>
        </div>

        <div class="w-1/2">
          <p>Loss Runs</p>
          <ng-container *ngIf="viewSubmissionStore.lossRunDocuments().length > 0">
            @for(lossrun of viewSubmissionStore.lossRunDocuments(); track lossrun) {
                <lib-button class="underline" [cssType]="'btn-link'"  [buttonType]="'button'"  [text]="lossrun?.name ?? ''" [size]="'medium'" (click)="downloadDocument(lossrun?.id ?? '')"></lib-button><br>
            }
          </ng-container>
        </div>
      </div>
    </div>
  }

  <div class="flex flex-col w-full lg:w-3/4 mx-auto">
    @if (model().requestType !== 'Bind' && hasFieldOwners()) {
      <table class="mt-[35px] submission-review-table">
        <thead>
          <tr>
            <th class="text-left">Classifications</th>
            <th class="text-right">Percentage of Work</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let classification of model().classPercentagesOfWork ?? {} | keyvalue">
            <td>{{classification.key}}</td>
            <td class="text-right">{{classification.value}}%</td>
          </tr>
        </tbody>
      </table>
    } @else if (model().requestType !== 'Bind') {
      <table class="mt-[35px] submission-review-table">
        <thead>
          <tr>
            <th class="text-left">Classifications</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let classification of model().classifications ?? {} | keyvalue">
            <td>{{classification.key}}</td>
            <td class="text-right">{{classification.value | currency:'USD' }}</td>
          </tr>
        </tbody>
      </table>
      <div class="flex w-full mt-1">
        <div class="w-full flex justify-end">
          <p class="bold">Total Payroll: {{model().totalPayroll| currency:'USD' }}</p>
        </div>
      </div>
    }

    @if (model().percentageOfWork && model().requestType !== 'Bind') {
      <table class="mt-[35px] submission-review-table">
        <thead>
          <tr>
            <th class="text-left">Percentage of Work</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let classification of model().percentageOfWork ?? {} | keyvalue">
            <td>{{classification.key}}</td>
            <td class="text-right">{{classification.value}}%</td>
          </tr>
        </tbody>
      </table>
      <div class="flex w-full mt-1">
        <div class="w-full flex justify-end">
          <p class="bold">Total 100%</p>
        </div>
      </div>
    } 

    @if (endorsements && endorsements.length > 0) {
      <table class="mt-[35px] submission-review-table">
        <thead>
          <tr>
            <th class="text-left">Optional Forms & Coverages</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let endorsement of endorsements">
            <td class="text-left">{{ endorsement[0] }}</td>
            <td class="text-right">{{ endorsement[1] }}</td>
          </tr>
        </tbody>
      </table>
    }


    <table class="mt-[35px] submission-review-table">
      <thead>
        <tr>
          <th class="text-left">General Liability Policy Totals</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Rated Premium</td>
          <td class="text-right">{{model().ratedPremium | currency:'USD' }}</td>
        </tr>
        <tr>
          <td>Inspection Fee</td>
          <td class="text-right">{{model().inspectionFee | currency:'USD' }}</td>
        </tr>
        <tr>
          <td>MGA Fee</td>
          <td class="text-right">{{model().mgaFee | currency:'USD' }}</td>
        </tr>
        <tr *ngFor="let classification of model().additionalFees ?? {} | keyvalue">
          <td>{{classification.key}}</td>
          <td class="text-right">{{classification.value | currency:'USD' }}</td>
        </tr>
        <tr>
          <td>Retail Broker Fee</td>
          <td class="text-right">{{model().brokerFee | currency:'USD' }}</td>
        </tr>
        <tr>
          <td>Surplus Lines Tax</td>
          <td class="text-right">{{model().surplusLinesTax | currency:'USD' }}</td>
        </tr>
        <tr>
          <td>Stamping Office Fee</td>
          <td class="text-right">{{model().stampingOfficeFee | currency:'USD' }}</td>
        </tr>
      </tbody>
    </table>
    <div class="flex w-full mt-1" *ngIf="authStore.isAdmin() || authStore.isWholesale()">
      <div class="w-full flex justify-end">
        <p>Schedule Credit Applied: {{model().scheduleCredit}}</p>
      </div>
    </div>
    <div class="flex w-full mt-1">
      <div class="w-full flex justify-end">
        <h4 class="bold">Quote {{ model().total | currency:'USD' }}</h4>
      </div>
    </div>
  </div>
}